import { API } from 'aws-amplify'

import { CategoryDto, CreateCategoryDto } from 'types'

export const getCategory = async (categoryId: string): Promise<CategoryDto[]> => {
    return API.get('api', `/single/categories/${categoryId}`, {})
}

export const getMyCategories = async (): Promise<CategoryDto[]> => {
    return API.get('api', '/categories', {})
}

export const getMyCategoriesBySubjectAndGradeId = async (subjectId: string, gradeId: string): Promise<CategoryDto[]> => {
    return API.get('api', `/categories/${subjectId}/grade/${gradeId}`, {})
}

export const getCategories = async (subjectId: string | string[], gradeId: string | string[], createdBy: string | string[], allowIncludes = true): Promise<CategoryDto[]> => {
    const queryParams =  `?allowIncludes=${allowIncludes}`
    switch (createdBy) {
        case 'quizedu':
            return API.get('api', `/official/categories/${subjectId}/grade/${gradeId}${queryParams}`, {})
        case 'mig':
            return API.get('api', `/mine/categories/${subjectId}/grade/${gradeId}${queryParams}`, {})
        case 'andre':
            return API.get('api', `/others/categories/${subjectId}/grade/${gradeId}${queryParams}`, {})
        default:
            break;
    }
}

export const getAllAvailableCategories = async(): Promise<CategoryDto[]> => {
    return API.get('api', `/categories/all`, {})
}

export const getMyCategoriesPerSubjectId = async (subjectId: string | string[]): Promise<CategoryDto[]> => {
    return API.get('api', `/categories/subject/${subjectId}`, {})
}


export const createCategory = async ({ name, subject, grade }: CreateCategoryDto): Promise<string> => {
    return API.post('api', `/categories`, { body: { name, subject, grade } })
}


export const updateCategory = async (categoryId: string, { name, subject, grade }: CreateCategoryDto): Promise<CategoryDto> => {
    return API.put('api', `/categories/${categoryId}`, { body: { name, subject, grade } })
}

export const deleteCategory = async (categoryId: string): Promise<string> => {
    return API.del('api', `/categories/${categoryId}`, {})
}

export const getMySubjects = async (grades: string[]): Promise<string[]> => {
    return API.get('api', `/subjects?grades=${grades.join(',')}`, {})
}